<template lang="html">
  <div class="result-camp">
    <h1>请务必添加课程学姐微信哦</h1>
    <p>加入训练营，与老师同学一起学习</p>
    <img :src="qrCode" alt="">
    <p>扫一扫上面的二维码，加我微信</p>
  </div>
</template>

<script>
export default {
  name: 'ResultCamp',
  props: ['qrCode']
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.result-camp {
  line-height: 1.4;
  h1 {
    color: #333333;
    font-weight: bolder;
    font-size: rem(40);
    margin-top: rem(50);
    margin-bottom: rem(20);
  }
  img {
    width: rem(440);
    height: rem(440);
    margin-bottom: rem(30);
  }
  p {
    font-size: rem(30);
    color: #999999;
    margin-bottom: rem(60);
    &:last-child {
      font-size: rem(24);
    }
  }
}
</style>
